import { Cancel01Icon, Menu01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Divider, Drawer, IconButton, MenuItem, Stack } from "@mui/material";
import { useResponsive } from "@/hooks";

export interface MenuItem {
  label: string;
  url: string;
  target: "self" | "_blank";
}

export interface MenuItems {
  menuItems?: MenuItem[];
  isEditor: boolean;
}

type Props = MenuItems;

const MyMenu = ({ menuItems = [], isEditor }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { isMobile } = useResponsive();

  return isMobile ? (
    <div>
      <IconButton id="basic-button" onClick={handleClick}>
        <HugeiconsIcon icon={Menu01Icon} />
      </IconButton>

      <Drawer
        open={open}
        anchor="top"
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: "100%",
            padding: 2,
          },
        }}
      >
        <Stack alignItems={"flex-end"}>
          <IconButton onClick={handleClose}>
            <HugeiconsIcon icon={Cancel01Icon} />
          </IconButton>
          <Divider />
        </Stack>
        <div>
          {menuItems.map((i, index) => (
            <ul
              key={`${i}-${index}`}
              style={{
                padding: "0px",
                listStyleType: "none",
              }}
            >
              <li
                style={{
                  padding: "8px",
                }}
              >
                <Link
                  style={{
                    display: "flex",
                    flex: 1,
                    justifyContent: "center",
                  }}
                  to={i.url}
                >
                  {i.label}
                </Link>
              </li>
            </ul>
          ))}
        </div>
      </Drawer>
    </div>
  ) : (
    <Stack direction={"row"} flex={1} spacing={2}>
      {menuItems.map((i, index) => (
        <li
          key={`${i}-${index}`}
          style={{
            padding: "0px",
            listStyleType: "none",
          }}
        >
          <Link
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "center",
              textDecoration: "none",
              color: "inherit",
            }}
            to={!isEditor ? i.url : null}
          >
            {i.label}
          </Link>
        </li>
      ))}
    </Stack>
  );
};

export default MyMenu;
